//import '@/plugins/vue-composition-api'

import '@/plugins/moments'
import '@/plugins/vue-signature-pad'
import '@/plugins/axios'

import Vue from 'vue'
import App from './App.vue'
import VErrorAlert from '@/components/ErrorAlert.vue';
import VWarningAlert from '@/components/WarningAlert.vue';
import VSuccessAlert from '@/components/SuccessAlert.vue';
import VFilterTextbox from '@/components/FilterTextbox.vue';
import VFeedbackSnackbar from '@/components/FeedbackSnackbar.vue';
import VNavigationBreadcrums from '@/components/NavigationBreadcrums.vue';

import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.component('v-feedback-snackbar', VFeedbackSnackbar);

Vue.component('v-error-alert', VErrorAlert);
Vue.component('v-warning-alert', VWarningAlert);
Vue.component('v-success-alert', VSuccessAlert);
Vue.component('v-filter-textbox', VFilterTextbox);
Vue.component('v-navigation-breadcrums', VNavigationBreadcrums);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
